import React from "react";
import { Container, ImageButton } from "./WhatsButton.styles";

const WhatsAppButton = () => {
  return (
    <Container className="tooltip">
      <span className="tooltiptext">Falar com Suporte</span>
      <ImageButton
        onClick={() => window.open("https://api.whatsapp.com/send?phone=5511940827479", "_blank")}
        src="images/whatsapp-btn.png"
        alt="Fale com o Suporte"
      />
    </Container>
  );
};

export default WhatsAppButton;